import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({

    centered: {
        textAlign: "center",
    },

    leftAligned: {
        textAlign: "left",
    },

    smallTopMargin: {
        marginTop: "4px",
    },

    topSpace: {
        marginTop: "0.75em",
    },

    bottomSpace: {
        marginBottom: "0.75em",
    },

    recentActivityGrid: {
        margin: "8px 0 0 0"
    },
    
    tooltipOffset: {
        marginTop: "-32px",
        marginRight: "80px",
    },
    
    accessHolderTitle: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    },

}));